import { Component } from "react";
import { Nav } from "react-bootstrap";
import ChevronListItem from "@/components/react/ChevronListItem";
import * as t from "@/lib/backend/manufacturing2.generated.types";

type Props = {
    filter: string;
    plantFilter: string;
    selected: t.ILineGroupData | null;
    lines: t.ILineData[];
    line_groups: t.ILineGroupData[];
    plant_uuid_to_title: Map<string, string>;
    handleItemClick: (line: t.ILineGroupData) => void;
};

class LineGroupsList extends Component<Props> {
    handleItemClick(line: t.ILineGroupData) {
        // Ignore clicks for currently selected line.
        if (line === this.props.selected) {
            return;
        }
        // Handle parent's click events.
        this.props.handleItemClick(line);
    }

    includes(needle: string, line_group: t.ILineGroupData): boolean {
        needle = needle.toLowerCase();
        if (needle.length === 0) return true;
        if (line_group.title.toLowerCase().indexOf(needle) > -1) return true;
        if (line_group.external_id.toLowerCase().indexOf(needle) > -1) return true;

        return false;
    }

    render() {
        const linegroupsList = this.props.line_groups.map(line_group => {
            let is_active = this.props.selected === line_group;

            if (this.props.plantFilter && !line_group.plant_uuids.includes(this.props.plantFilter)) {
                return null;
            }
            if (!this.includes(this.props.filter, line_group)) return null;

            // Prepare plant title
            const plant_title = line_group.plant_uuids
                .filter(uuid => this.props.plant_uuid_to_title.has(uuid))
                .map(uuid => this.props.plant_uuid_to_title.get(uuid))
                .join(", ");

            return (
                <ChevronListItem
                    key={line_group.uuid}
                    text={line_group.title}
                    subtext={plant_title}
                    onClick={() => this.handleItemClick(line_group)}
                    is_active={is_active}
                />
            );
        });

        return (
            <Nav variant="tabs">
                <div className="nav-tabs-parent">{linegroupsList}</div>
            </Nav>
        );
    }
}

export default LineGroupsList;
